import Vue from 'vue'
import Router from 'vue-router'
import { generateRoutes } from "./permission";
// import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

// export default new Router({
//   routes: [
//     // {
//     //   path: '/',
//     //   name: 'HelloWorld',
//     //   component: HelloWorld
//     // }
//   ]
// })


const router = new Router({
  mode: 'history', // 去掉路径中的 # 号
  routes: [{
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        title: '登录'
      },
      component: () => import('@/view/Login.vue')
    },
    {
      path: '/mesvt/subVtUrl',
      name: 'payment',
      meta: { title: '支付' },
      component: () => import('@/view/payment/Payment.vue')
    },
    {
      path:'/mesvt/payResult',
      name: 'PayResult',
      meta: { title: '回显' },
      component:()=>import('@/view/payment/PayResult.vue')
    },

    {
      path:'/home',
      name:'home',
      meta:{
        title:'home',
        names: {
          'zh-CN': '首页',
          'en-US': 'Home'
        }
      },
      component:() => import('@/view/Home.vue'),
      children:[
        {
          path:'dashboard/Index',
          name:'dashboard',
          meta:{
            title:'dashboard',
            names: {
              'zh-CN': '仪表盘',
              'en-US': 'Dashboard'
            }
          },
          component:() => import('@/view/dashboard/Index.vue')
        }
      ]
    }
  ]
})

let hasAddRoutes = false;
// 挂载路由导航守卫：to表示将要访问的路径，from表示从哪里来，next是下一个要做的操作
router.beforeEach((to, from, next) => {
  const whiteList = ['/login', '/mesvt/subVtUrl','/mesvt/payResult'];
/*  if (to.path === "/login") {
    return next();
  }*/
  if (whiteList.includes(to.path)) {
    return next();
  }

  const token = sessionStorage.getItem("token");

  if (!token) {
    return next("/login");
  }

/*  const menus =
    JSON.parse(sessionStorage.getItem("menus") || "[]");

  if (router.getRoutes().length <= 4) {

    const routes = generateRoutes(menus);

    routes.forEach(route => {
      router.addRoute("home", route);
    });


    return next({
      ...to,
      replace: true
    });
  }*/
  if (!hasAddRoutes) {
    const menus = JSON.parse(sessionStorage.getItem("menus") || "[]");

    if (menus.length > 0) {
      const routes = generateRoutes(menus);
      //console.log("生成路由", routes);

      routes.forEach(route => {
        router.addRoute("home", route);
      });

      //console.log("当前全部路由", router.getRoutes().map(v => v.path));

      // 标记为已添加
      hasAddRoutes = true;

      return next({ ...to, replace: true });
    }
  }

  next();

})






export default router



// WEBPACK FOOTER //
// ./src/router/index.js